import { Pipe, PipeTransform } from '@angular/core';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CalcTaxRequestViewModel, CalcTaxResponseViewModel } from '../../../model/src/public-api';
import { isNullOrEmpty } from '../../../util/src/public-api';
import { AppConfig } from '../../config/app.config';
import { ApiCommonService } from '../../core/services/api-common.service';


/**
 * 稅率金額 Pipe
 *
 * @export
 * @class TaxPipe
 * @implements {PipeTransform}
 * @description
 * 參數1: 稅率日期(yyyy-MM-dd)]
 * 註: 目前資料先以設定檔方式提供，之後可以改成 call api 取得
 */
@Pipe({
  name: 'tax'
})
export class TaxPipe implements PipeTransform {

  constructor(private commonApiService: ApiCommonService) {

  }

  get envConfig(): any {
    return AppConfig.envConfig;
  }

  transform(value: any, ...args: any[]): any {
    if (isNullOrEmpty(value)) {
      return of(null);
    }

    if (args.length < 1) {
      throw 'No parameters.';
    }

    const { specifyTaxRate, currency, taxCode, companyId, taxCalcMode, step, round } = args[0];
    const currencySettings = (this.envConfig.format.currencies ?? []) as any[];
    const currencySetting = currencySettings.find(x => x.currency === currency);
    if (isNullOrEmpty(currency) || isNullOrEmpty(currencySetting)) {
      return;
    }

    const req: CalcTaxRequestViewModel = {
      taxRateSrc: isNullOrEmpty(specifyTaxRate) ? 0 : 1,
      inputTaxRate: specifyTaxRate,
      currency,
      taxCode,
      companyId,
      taxCalcMode,
      specifyCarryDigit: this.getCarrayDigit(step ?? currencySetting.step),
      specifyCarryDigitMode: this.getCarrayDigitMode(round ?? currencySetting.round),
      amountList: [{ amount: value }]
    };
    const observable = this.commonApiService.taxCalcPost(req)
      .pipe(map(x => this.formatTaxResult(x)));
    return observable;
  }

  private getCarrayDigit(step: number): number {
    const str = step.toString();
    return str.indexOf('.') > -1 ? str.split('.')[1].length : 0 - (str.length - 1);
  }

  private getCarrayDigitMode(round: 'off' | 'up' | 'down'): number {
    return round === 'up' ? 2 : round === 'down' ? 1 : 0;
  }

  private formatTaxResult(result: CalcTaxResponseViewModel): string {
    let str = '';
    const taxStr = result.amountList![0].formattedTax;
    const currencyStr = result.currency ?? '';
    str = `${taxStr} ${currencyStr}`.trim();

    return str;
  }
}

export interface TaxRate {
  startDate: Date;
  endDate?: Date;
  taxRate: number;
}
